export default __webpack_public_path__ + "static/media/test.2131dc72.jpg";